import axiosInstance from './axiosInstance';
import { ICreateStationPayload } from '../interfaces/Station/ICreateStationPayload.ts';
import { ICreateStationResponse } from '../interfaces/Station/ICreateStationResponse.ts';
import { IStationListResponse } from '../interfaces/Station/IStationListResponse.ts';
import { ICareHome } from '../interfaces';
import { IStation } from '../interfaces/Station/IStation.ts';
import { IStationStats } from '../interfaces/Station/IStationStats.ts';

class StationService {
  private static instance: StationService;
  private constructor() {}

  public static getInstance(): StationService {
    if (!StationService.instance) {
      StationService.instance = new StationService();
    }
    return StationService.instance;
  }

  public async createStation(
    payload: ICreateStationPayload
  ): Promise<ICreateStationResponse> {
    try {
      const response = await axiosInstance.post<ICreateStationResponse>(
        '/stations',
        payload
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to create station');
    }
  }

  public async getListStations(
    page = 1,
    per_page = 10,
    query?: string,
    carehome_id?: string,
    is_active?: string,
    orderBy?: string,
    sortOrder?: 'asc' | 'desc'
  ): Promise<IStationListResponse> {
    try {
      const response = await axiosInstance.get<IStationListResponse>(
        '/stations',
        {
          params: {
            page,
            per_page,
            query,
            carehome_id,
            is_active,
            order_by: orderBy,
            sort_order: sortOrder,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch stations');
    }
  }

  public async getStation(stationId: string): Promise<IStation> {
    try {
      const response = await axiosInstance.get<IStation>(
        `/stations/${stationId}`
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch stations');
    }
  }

  public async deleteStation(station_id: string): Promise<void> {
    try {
      await axiosInstance.delete(`/stations/${station_id}`);
    } catch (error: any) {
      // Surface original error so callers can inspect response details
      throw error;
    }
  }

  public async updateStation(
    stationId: string,
    payload: ICreateStationPayload
  ): Promise<ICareHome> {
    try {
      const response = await axiosInstance.put<ICareHome>(
        `/stations/${stationId}`,
        payload
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to update station');
    }
  }

  public async getStationStats(stationId: string): Promise<IStationStats> {
    try {
      const response = await axiosInstance.get<IStationStats>(
        `/stations/${stationId}/stats`
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch station stats');
    }
  }
}

export default StationService.getInstance();
